import { render } from "./BalancerControl.vue?vue&type=template&id=3124d4a4&scoped=true"
import script from "./BalancerControl.vue?vue&type=script&lang=js"
export * from "./BalancerControl.vue?vue&type=script&lang=js"

import "./BalancerControl.vue?vue&type=style&index=0&id=3124d4a4&lang=scss&scoped=true"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3124d4a4"]])

export default __exports__